import React from 'react'
import "./Copytext.css"

const Copytext = () => {
    const textToCopy = "Gallie8699@gmail.com"

    const handleCopy= () =>{
        navigator.clipboard.writeText(textToCopy)
    };
  return (
    <div  onClick={handleCopy}>
        <p className='handleCopy'>griffin.allison@proton.me</p>

    </div>
  )
}
export default Copytext